module.exports = __webpack_public_path__ + "static/media/0.dca7ac21.jpg";